module.exports = __webpack_public_path__ + "static/media/img-verification-email-sent.84a1f037.svg";